import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";

import { Appointment } from "@secondcloset/types/src/fulfillment";

import * as S from "./styles";
import { COLORS } from "styles";

import { useRecoilValue } from "recoil";
import { colorState } from "recoil/colourPicker/atoms";

import { Column, Row, Text } from "components/common";
import { AppointmentUtils } from "lib/AppointmentUtils";

import { MenuItem } from "../MenuItem";

const GOBOLT_SUPPORT_BASE_URL = process.env.REACT_APP_GOBOLT_SUPPORT_BASE_URL || "https://help.gobolt.com";

export const Support: FC = () => {
  const color = useRecoilValue(colorState);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const appointment = queryClient.getQueryData<Appointment>("appointment");
  const isReloAppointment = AppointmentUtils.checkIsReloAppointment(appointment);

  //TODO: update "How to prepare.." link for french once it's available
  return (
    <MenuItem title={t("Support")} renderIcon={() => <S.Phone width={24} color={color} />}>
      <Column padding="0 16px 16px">
        <Row alignItems="center" margin="8px 0 8px">
          <S.QuestionCircleIcon />
          <Text fontWeight={600} color={COLORS.BLUE} textDecoration="underline">
            <S.Link
              href={
                i18n.language === "en"
                  ? `${GOBOLT_SUPPORT_BASE_URL}/en/articles/2637889`
                  : `${GOBOLT_SUPPORT_BASE_URL}/en/articles/2637889`
              }
              target="_blank"
            >
              {t(`How to prepare for your ${isReloAppointment ? "return" : "delivery"}`)}
            </S.Link>
          </Text>
        </Row>
        <Row alignItems="center" margin="8px 0 24px">
          <S.InfoCircleIcon />
          <Text fontWeight={600} color={COLORS.BLUE} textDecoration="underline">
            <S.Link href={GOBOLT_SUPPORT_BASE_URL} target="_blank">
              {t("Visit our help centre")}
            </S.Link>
          </Text>
        </Row>
      </Column>
    </MenuItem>
  );
};
